import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";
// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";
// views without layouts
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
//Redux integration
import { store } from './redux/store'
import { Provider } from 'react-redux'
//Protected Route
import PrivateRoute from './redux/features/authenticate/PrivateRoute';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        {/* add routes with layouts */}
        <PrivateRoute path="/admin" component={Admin} />
        <Route path="/auth" component={Auth} />
        {/* add routes without layouts */}
        <PrivateRoute path="/landing" exact component={Landing} />
        <PrivateRoute path="/profile" exact component={Profile} />
        
        {/* add redirect for first page */}
        <Redirect from="*" to="/admin" />
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
